import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {salarySlipActions} from "./salarySlipSlice";
import {salarySlipApi} from "~/api";

function* fetchSalarySlipList(action) {
	try {
		const response = yield call(salarySlipApi.gets, action.payload);
		yield put(salarySlipActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch salary slip list', error);
		yield put(salarySlipActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(salarySlipActions.setFilter(action.payload));
}

export default function* salarySlipSaga() {
	yield takeLatest(salarySlipActions.fetchData.type, fetchSalarySlipList);
	yield debounce(500, salarySlipActions.setFilterWithDebounce.type, handleSearchDebounce)
}
